import * as types from '../actionTypes/auditLog'

let defaultState = {
  auditLogEntries: [],
  typeNames: []
}

const auditLogReducer = (state = defaultState, action) => {
  if (action.type === types.GET_AUDIT_LOG_TYPE_NAMES) {
    return {
      ...state,
      typeNames: action.typeNames
    }
  }
  else if (action.type === types.GET_AUDIT_LOG_ENTRIES) {
    return {
      ...state,
      auditLogEntries: action.auditLogEntries
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default auditLogReducer;


// WEBPACK FOOTER //
// ./src/reducers/auditLog.js